import CacheHelper from "@/helper/CacheHelper";
export class LineTokenModel {
    constructor(){
        this.token = null
        this.cacheKey = 'line_id_token_landing'
    }
    setLineIdToken(token){
        this.token = token
    }
    saveCache(){
        let data = {
            token: this.token
        }
        let cache = new CacheHelper("session");
        cache.setCache(this.cacheKey, data);
    }
    loadCache(){
        let cache = new CacheHelper("session");
        let cacheTokenLine = cache.getCache(this.cacheKey);
        if(cacheTokenLine != null){
            this.token = cacheTokenLine.token
        }
    }
}
